import { useState, useEffect } from 'react'
import classnames from 'classnames'

import { withTranslate } from '@i18n/utils'

import { pendingSelector } from 'api/selectors'

import {
    selectedVehicleSelector,
    lastBookingBasketItemSelector,
    promoCodeBarcodeSelector,
    rawPromoCodeSelector,
} from 'booking/selectors'
import { lastBookingRedeemPromoCode, lastBookingRemovePromoCode, setRawPromoCode } from '@booking/actions'
import { selectVehicle } from 'booking/actions'

import { PromoCode } from '../../PromoCode'

import bookingStyles from './styles.module.scss'

const PromoCodeSection = ({
    rawPromoCode,
    setRawPromoCode,
    lastBookingRemovePromoCode,
    promoCodeBtnDisabled,
    currentItemIndex,
    rate,
    waitingListKey,
    user,
    lastBookingBasketItem,
    lastBookingRedeemPromoCode,
    promoCodePending,
    selectedVehicle,
    promoCodeBarcode,
}) => {
    const isPromoCodePending = promoCodePending[`redeemPromoCode${currentItemIndex}`]
    const promoCodePendingError = isPromoCodePending instanceof Error ? isPromoCodePending.message : ''

    const [promoCodeError, setPromoCodeError] = useState(promoCodePendingError)
    const [successPromoCode, setSuccessPromoCode] = useState(false)

    useEffect(() => {
        setPromoCodeError(promoCodePendingError)
    }, [promoCodePendingError])

    const onAddPromoCode = () => {
        lastBookingRedeemPromoCode({
            id: currentItemIndex,
            rate: { ...rate, waitingListKey },
        })
    }

    useEffect(() => {
        if (selectedVehicle.length === 0 && user) {
            rawPromoCode !== '' && onAddPromoCode()
        }
    }, [user])

    useEffect(() => {
        !rawPromoCode && lastBookingRemovePromoCode()

        if (rawPromoCode) {
            lastBookingRedeemPromoCode({
                id: currentItemIndex,
                rate: { ...rate, waitingListKey },
            })
        }
    }, [rate])

    useEffect(() => {
        if (!!promoCodeBarcode && lastBookingBasketItem?.promoCode?.statusCode === 200) {
            setSuccessPromoCode(true)
        }
        if (rawPromoCode === '') {
            setSuccessPromoCode(false)
        }
    }, [lastBookingBasketItem?.promoCode, rawPromoCode])

    useEffect(() => {
        if (rawPromoCode !== '' && lastBookingBasketItem?.promoCode?.statusCode === -1) {
            setPromoCodeError(<T>booking.promo.code.error</T>)
        }
    }, [lastBookingBasketItem?.promoCode])

    return (
        <div className={classnames('d-inline-flex mt-4 p-0', bookingStyles.promoCodeContainer)}>
            <PromoCode
                promoCodeValue={rawPromoCode}
                setRawPromoCode={setRawPromoCode}
                onRemovePromoCode={lastBookingRemovePromoCode}
                onAddPromoCode={onAddPromoCode}
                removePromoCodeLabel={<T>booking.promocode.remove</T>}
                btnLabel={<T>booking.promocode.apply</T>}
                placeholder={<T>booking.hourly.flow.promocode.placeholder</T>}
                error={promoCodeError}
                success={successPromoCode}
                btnStyle={'primary'}
                disabled={promoCodeBtnDisabled}
                isLoading={isPromoCodePending === true}
            />
        </div>
    )
}

export default compose(
    withTranslate,
    connect(
        createStructuredSelector({
            selectedVehicle: selectedVehicleSelector,
            promoCodeBarcode: promoCodeBarcodeSelector,
            rawPromoCode: rawPromoCodeSelector,
            promoCodePending: pendingSelector,
            lastBookingBasketItem: lastBookingBasketItemSelector,
        }),
        {
            selectVehicle,
            lastBookingRedeemPromoCode,
            setRawPromoCode,
            lastBookingRemovePromoCode,
        }
    )
)(PromoCodeSection)
